

export class UserInfo {
    login?: string;
    jmeno?: string;
}